import { render, staticRenderFns } from "./LineOfSupervisionsPage.vue?vue&type=template&id=36cf6e1c&scoped=true"
import script from "./LineOfSupervisionsPage.vue?vue&type=script&lang=js"
export * from "./LineOfSupervisionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf6e1c",
  null
  
)

export default component.exports